// Типы объектов, возможные к выбору для составления аналитического отчета
export const analyticsObjects: any = {
    "Категорийный участок дороги": "RoadCategorySegments",
    "Прохождение по районам": "RoadRaionSegments",
    "Прохождение по населённым пунктам": "RoadIntraurbanSegments",
    "Участки обслуживания": "RoadServiceSegments",
    "Топографические условия прохождения": "RoadReliefSegments",
    "Прохождение по дорожно-климатическим зонам": "RoadClimaticZoneSegments",
    "Кривые в плане": "RoadCurveRadiusSegments",
    "Элементы продольного профиля": "LongitudinalSlopeSegments",
    "Совмещённые участки дороги": "RoadOverlapSegments",
    "Недостающие дорожные объекты": "RoadMissingObjects",
    "Участки инноваций": "InnovationSegments",
    "Участки инвестиций": "InvestmentSegments",
    "Платные участки": "TollRoadSegments",
    "Участки опорных сетей": "HighwayNetworkSegment",
    "Проезжая часть": "RoadDrivewaySegments",
    "Покрытие проезжей части": "RoadCoverSegments",
    "Обочины": "RoadEdgeSegments",
    "Разделительные полосы": "RoadDemarcationStripSegments",
    "Полосы уширения": "RoadAccelLines",
    "Дорожная одежда": "RoadBedLayerSegments",
    "Тротуары, пешеходные и велосипедные дорожки": "RoadSidewalks",
    "Бордюры": "RoadBorders",
    "Верх земляного полотна": "RoadbedSegments",
    "Откосы земляного полотна": "RoadSlopeSegments",
    "Проблемные участки": "RoadProblemSegments",
    "Мостовые сооружения": "RoadRiverBridges",
    "Водопропускные трубы": "RoadWaterPipes",
    "Водоотведение": "RoadDrainageSegments",
    "Подземная ливневая канализация": "Подземная ливневая канализация",
    "Футляры ливневой канализации": "Футляры ливневой канализации",
    //"Колодцы ливневой канализации"  "" ,
    // "" "Очистные сооружения",
    "Паромные переправы": "RoadFerrys",
    "Ледовые переправы": "RoadIceBridges",
    "Тоннели": "RoadTunnels",
    "Железнодорожные переезды": "RoadRailWayCrossings",
    "Пересечения и примыкания": "RoadIntersections",
    "Съезды": "RoadExits",
    "Снегозащитные сооружения": "RoadSnowProtections",
    "Шумозащитные сооружения": "RoadNoiseBarriers",
    "Подпорные стенки": "RoadBreastWalls",
    "Дорожные знаки": "RoadSigns",
    "Километровые столбы": "RoadDistanceMarks",
    "Опоры элементов инженерного обустройства": "RoadSignColumns",
    "Дорожная разметка": "RoadMarkingSections",
    "Светофорные объекты": "RoadSemaphoreObjects",
    "Ограждения": "RoadFenceSegments",
    "Сигнальные столбики": "RoadGuideStakeSegments",
    "Направляющие устройства": "RoadGuideEquipments",
    "Пешеходные переходы": "RoadCrosswalks",
    "Участки освещения": "RoadLightingSegments",
    "Элементы АСУДД": "RoadAutomatedSystemElements",
    "Шумовые полосы": "RoadRumbleStrips",
    "Искусственные неровности": "RoadSpeedBumps",
    // "Трамвайные пути" "" ,
    // "" "Троллейбусные контактные сети",
    "Земельные участки дороги": "RoadLandLots",
    "Смежные земельные участки": "AdjacentLandLots",
    "Придорожные полосы": "Waysides",
    "Прилегающие угодья": "RoadJoinedGroundss",
    "Коммуникации": "RoadUtilityObjects",
    "Колодцы коммуникаций": "RoadWells",
    "Озеленение": "RoadGreenLines",
    "Площадки": "RoadSites",
    "Рекламные щиты": "RoadBillboards",
    "Стелы и памятники": "RoadSteles",
    "Пункты геодезической сети": "RoadRefpoints",
    "Здания": "RoadBuildings",
    "Посты ГИБДД": "RoadPolicePosts",
    "Здания дорожной службы": "RoadServiceBuildings",
    "Пункты оплаты": "RoadTollStations",
    "Пункты весового контроля": "RoadWeightControls",
    "Автозаправочные станции": "RoadGasStations",
    "Станции техобслуживания": "RoadTechServiceStations",
    "Автомойки": "RoadWashingPoints",
    "Пункты связи": "RoadCommunicationPoints",
    "Парковки": "RoadParkings",
    "Остановки общественного транспорта": "RoadBusstops",
    "Автовокзалы": "RoadBusStations",
    "Автостанции": "BusDepots",
    "Пункты питания": "RoadPublicCaterings",
    "Пункты торговли": "RoadOutlets",
    "Гостиницы": "RoadHotels",
    "Пункты медицинской помощи и больницы": "RoadMedicalCares",
    "Туалеты": "RoadToilets",
    "Объекты сервиса": "RoadServiceObjects",
    "Комплексные объекты сервиса": "RoadMultiFunctionAreas",
    "Участки проведения работ": "RoadWorkSegments",
    "Участки диагностики": "RoadDiagnosticsSegments",
    "Пункты учёта интенсивности": "RoadTrafficIntensityNodes",
    "Дорожно-транспортные происшествия": "RoadAccidents",
}

// Категории типов объектов для составления аналитического отчета
export enum analyticsObjectCategories {
    'Логические участки' = 'Логические участки',
    'Участки дороги' = 'Участки дороги',
    'Сооружения' = 'Сооружения',
    'Подземная ливневая канализация' = 'Подземная ливневая канализация',
    'Инженерное обустройство' = 'Инженерное обустройство',
    'Объекты придорожной полосы' = 'Объекты придорожной полосы',
    'Объекты дорожных служб' = 'Объекты дорожных служб',
    'Объекты сервиса' = 'Объекты сервиса',
    'События на дороге' = 'События на дороге'
}